import React from 'react';
import './Tabs.css';
import './CountBadge.css';
import Tooltip from './Tooltip';

/**
 * Underline-style tab row (labels use global h3 typography + optional icons).
 * items: [{ value: string, icon?: ReactNode, label?: string, badge?: number, tooltip?: string }]
 */
const Tabs = ({
    items = [],
    value,
    onChange,
    ariaLabel,
    className = '',
}) => {
    if (!items || items.length === 0) return null;

    const handleClick = (itemValue) => {
        if (itemValue === value) return;
        if (onChange) onChange(itemValue);
    };

    return (
        <div
            className={`tabs ${className}`}
            role="radiogroup"
            aria-label={ariaLabel}
        >
            {items.map((item, idx) => {
                if (!item || (!item.icon && !item.label)) return null;
                const key = item.value ?? idx;
                const isActive = item.value === value;
                const button = (
                    <h3 className="tabs-tab-label">
                        <button
                            type="button"
                            className={`tabs-tab${isActive ? ' tabs-tab--active' : ''}`}
                            onClick={() => handleClick(item.value)}
                            aria-pressed={isActive}
                        >
                            <span className="tabs-tab-inline">
                                {item.icon && (
                                    <span className="tabs-tab-icon">
                                        {item.icon}
                                    </span>
                                )}
                                {item.label}
                            </span>
                            {Number.isFinite(item.badge) && (
                                <span className="tabs-tab-badge count-badge" aria-hidden="true">
                                    {item.badge}
                                </span>
                            )}
                        </button>
                    </h3>
                );
                return (
                    <React.Fragment key={key}>
                        {item.tooltip ? (
                            <Tooltip content={item.tooltip}>{button}</Tooltip>
                        ) : (
                            button
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default Tabs;
